import apiClient from '@/api';
import { PaginatedResponse } from '@/utils/types';
import { ProcessObject } from './types';
import { PROCESS_OBJECTS_ROOT_API_URL } from './constants';
import { useQuery } from '@tanstack/react-query';

export function queryProcessObjectList(ids: string[]) {
	const idList = ids.map(id => `ids=${id}`).join('&');

	return apiClient.get<PaginatedResponse<ProcessObject>>(
		`${PROCESS_OBJECTS_ROOT_API_URL}?${idList}&page=1&limit=100`
	);
}

export const useGetProcessObjectsByIds = (ids: string[], isEnabled: boolean) => {
	const { data: paginatedProcessObjects } = useQuery({
		queryKey: ['process-objects', ids],
		queryFn: () => queryProcessObjectList(ids),
		enabled: isEnabled
	});

	return { paginatedProcessObjects };
};
